import React from "react";
import { Button } from "primereact/button";
import ZirvuFileManagerButton from "@components/zirvu-file-manager/ZirvuFileManagerInput";

const JenisMobilPhotoSection = ({
  field,
  name,
  data,
  setData,
  photos = [],
  folderName,
  disabled,
  error,
}) => {
  const currentUrl = data[field] || "";
  const currentIndex = photos.findIndex((p) => p.url === currentUrl);

  const handlePrev = (e) => {
    e.preventDefault();
    if (!photos || photos.length === 0) return;
    let nextIdx = currentIndex - 1;
    if (nextIdx < 0) {
      nextIdx = photos.length - 1;
    }
    setData((prev) => ({
      ...prev,
      [field]: photos[nextIdx].url,
    }));
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (!photos || photos.length === 0) return;
    let nextIdx = currentIndex + 1;
    if (nextIdx >= photos.length) {
      nextIdx = 0;
    }
    setData((prev) => ({
      ...prev,
      [field]: photos[nextIdx].url,
    }));
  };

  const handleClear = (e) => {
    e.preventDefault();
    setData((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const currentPhotoInfo = currentIndex >= 0 ? photos[currentIndex] : null;

  return (
    <div className="col-start-start w-full gap-2 p-2 border border-slate-200 rounded-lg bg-slate-50/50">
      {/* Top Header: Title and Clear Button */}
      <div className="row-between-center w-full">
        <label htmlFor={field} className="font-bold text-sm text-slate-700">
          {name}
        </label>
        {currentUrl && (
          <Button
            className="max-w-[1.6rem] max-h-[1.6rem] !p-0"
            icon="pi pi-times"
            text
            rounded
            severity="danger"
            tooltip="Hapus foto"
            tooltipOptions={{ position: "left" }}
            onClick={handleClear}
          />
        )}
      </div>

      {/* Navigation Toolbar between Pengecekan Photos */}
      <div className="row-between-center w-full px-2 py-1 bg-white rounded border border-slate-200">
        <Button
          type="button"
          icon="pi pi-chevron-left"
          rounded
          text
          className="max-w-[1.8rem] max-h-[1.8rem] !p-0"
          disabled={disabled || photos.length <= 1}
          tooltip="Foto sebelumnya"
          tooltipOptions={{ position: "top" }}
          onClick={handlePrev}
        />

        <div className="col-center-center text-center px-1 overflow-hidden">
          {photos.length > 0 ? (
            currentIndex >= 0 ? (
              <>
                <span className="text-xs font-bold text-slate-700 leading-tight">
                  Foto {currentIndex + 1} / {photos.length}
                </span>
                <span className="text-[10px] text-slate-500 truncate max-w-[15rem] leading-tight">
                  {currentPhotoInfo?.nomor_polisi || "-"} •{" "}
                  {currentPhotoInfo?.tanggal || "-"} (
                  {currentPhotoInfo?.tipe || "-"})
                </span>
              </>
            ) : currentUrl ? (
              <>
                <span className="text-xs font-bold text-indigo-600 leading-tight">
                  Foto Kustom / Upload
                </span>
                <span className="text-[10px] text-slate-400 leading-tight">
                  ({photos.length} riwayat tersedia)
                </span>
              </>
            ) : (
              <span className="text-xs text-slate-500 font-medium">
                {photos.length} foto riwayat tersedia
              </span>
            )
          ) : (
            <span className="text-[11px] text-slate-400 italic">
              Tidak ada foto riwayat
            </span>
          )}
        </div>

        <Button
          type="button"
          icon="pi pi-chevron-right"
          rounded
          text
          className="max-w-[1.8rem] max-h-[1.8rem] !p-0"
          disabled={disabled || photos.length <= 1}
          tooltip="Foto berikutnya"
          tooltipOptions={{ position: "top" }}
          onClick={handleNext}
        />
      </div>

      {/* Image Preview & Take Photo / Upload Button */}
      <ZirvuFileManagerButton
        disabled={disabled}
        width="100%"
        height="190px"
        value={currentUrl}
        directPhoto={true}
        folderName={folderName}
        onSelect={(event, newValue) => {
          const newUrl = newValue && newValue.url ? newValue.url : null;
          setData((prev) => ({
            ...prev,
            [field]: newUrl,
          }));
        }}
      />

      {error && error[field] && (
        <small className="font-semibold text-red-400">{error[field]}</small>
      )}
    </div>
  );
};

export default JenisMobilPhotoSection;
